import React, { useState } from 'react';
import Button from '@hubins/components/Button';

import { useMiddleman } from '@hubins/middleman';
import { useAuth } from '../../contexts/AuthContext';
import __ from 'localisation';
import ActivateTFAModal from '@hubins/components/ActivateTFAModal';



const AuthSettings = () => {
  const middleman = useMiddleman();
  const { user, updateUser } = useAuth();
  const tfa = user.tfa;


  const [loading, setLoading] = useState(false);
  const [QRCode, setQRCode] = useState(false);

  const activate = async () => {
    try {
      setLoading(true);
      const res = await middleman.get('/auth/tfa/enable');
      setQRCode(res.data.svg);
      setLoading(false);
    } catch (e) {
      console.error(e.message);
      setLoading(false);
    }
  };

  return (
    <div className='flex justify-start align-start'>
      <Button
        loading={loading}
        onClick={activate}
        disabled={tfa}
      >
        {__('tfa_required_title')}
      </Button>
      <ActivateTFAModal
        open={!!QRCode}
        setOpen={setQRCode}
        QRCode={QRCode}
        updateUser={updateUser}
      />

    </div>
  );

};

export default AuthSettings;
